export default __webpack_public_path__ + "static/media/credit-card-fail.2422aad8.jpeg";